var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountsPayable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.969 2.156h-1.567A2.156 2.156 0 0 0 14.375.72h-5.75a2.156 2.156 0 0 0-2.027 1.437H5.031a2.156 2.156 0 0 0-2.156 2.156v15.813a2.156 2.156 0 0 0 2.156 2.156H17.97a2.156 2.156 0 0 0 2.156-2.156V4.312a2.157 2.157 0 0 0-2.156-2.156zm-9.344 0h5.75a.719.719 0 0 1 0 1.438h-5.75a.719.719 0 0 1 0-1.438zM11.5 18.688a6.469 6.469 0 1 1 0-12.938 6.469 6.469 0 0 1 0 12.938z",
    fill: "#212134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.422 10.781h3.234a.719.719 0 1 0 0-1.437H12.22v-.719a.719.719 0 0 0-1.438 0v.719h-.36a1.797 1.797 0 1 0 0 3.594h2.157a.36.36 0 0 1 0 .718H9.344a.719.719 0 0 0 0 1.438h1.437v.719a.719.719 0 0 0 1.438 0v-.72h.36a1.797 1.797 0 0 0 0-3.593h-2.157a.36.36 0 0 1 0-.719z",
    fill: "#212134"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsPayable);
export default __webpack_public_path__ + "static/media/accounts-payable.c81c6cf8661cc029f97b2c10f4488633.svg";
export { ForwardRef as ReactComponent };